function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawSunnyDay = function UndrawSunnyDay(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1008 743.76",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 1327.64,
    y1: 813.14,
    x2: 1327.64,
    y2: 277.83,
    gradientTransform: "matrix(-1 0 0 1 1614 0)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M942.55 473.27c-34 43.17-20.77 106.25.81 156.76 7.22 16.91 15.4 34.81 12.35 52.94-3.73 22.18-23.52 38.4-44.3 47-37.88 15.67-83.22 11.93-118-9.72-30.08-18.71-51.63-49.15-82.22-67-51.2-29.89-116.38-18.6-172 2-39.34 14.57-82.34 33.51-121.43 18.29-27.5-10.71-46.51-36.79-56.87-64.43-5-13.34-8.63-27.79-18.18-38.37-5.68-6.29-13.09-10.75-20.68-14.51-69.31-34.37-156.85-16-224.17-54.08-45.47-25.74-74.57-74.3-87.46-124.93S-1 273.46 2.27 221.32c2.33-37.06 6.5-76.62 30.18-105.22 25-30.26 68-41.51 106.89-35.76s74.07 26.25 105.06 50.39c38.72 30.17 74.64 67.74 122.18 80 32.42 8.29 66.42 3.73 99.83 2.15 55.83-2.64 111.68 3.23 167.19 9.64 53.15 6.14 106.68 12.91 157.32 30.2 35.83 12.24 64.56 34.45 98.39 50 22.05 10.11 46.1 12.91 67 25.79 25.72 15.87 49.3 43.47 42.71 75.77-6.27 30.68-38.45 46.08-56.47 68.99z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 211.95,
    cy: 711.75,
    rx: 210.22,
    ry: 32.01,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 887.38,
    cy: 49.74,
    r: 49.74,
    fill: "#ffdf9c"
  }), React.createElement("path", {
    d: "M115.33 514.12s5.17 6.76-2.38 17-13.78 18.76-11.27 25.13c0 0 11.39-18.94 20.67-19.21s3.18-11.53-7.02-22.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M115.33 514.12a8.37 8.37 0 0 1 1.06 2.12c9 10.63 13.87 20.55 5.17 20.8-8.1.23-17.82 14.72-20.15 18.38a7.85 7.85 0 0 0 .28.83s11.39-18.94 20.67-19.21 3.17-11.53-7.03-22.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M124.93 522.73c0 2.38-.27 4.31-.6 4.31s-.6-1.93-.6-4.31.33-1.26.66-1.26.54-1.12.54 1.26z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M128.23 525.57c-2.09 1.14-3.91 1.83-4.07 1.54s1.41-1.45 3.5-2.58 1.26-.31 1.42 0 1.24-.1-.85 1.04z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M88 514.12s-5.17 6.76 2.38 17 13.82 18.76 11.3 25.13c0 0-11.39-18.94-20.67-19.21s-3.17-11.53 6.99-22.92z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M88 514.12a8.37 8.37 0 0 0-1.06 2.12c-9 10.63-13.87 20.55-5.17 20.8 8.1.23 17.82 14.72 20.15 18.38a7.85 7.85 0 0 1-.28.83S90.29 537.3 81 537.04s-3.16-11.53 7-22.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M78.43 522.73c0 2.38.27 4.31.6 4.31s.6-1.93.6-4.31-.33-1.26-.66-1.26-.54-1.12-.54 1.26z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M75.14 525.57c2.09 1.14 3.91 1.83 4.07 1.54s-1.41-1.45-3.5-2.58-1.26-.31-1.42 0-1.29-.1.85 1.04z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M80.08 555.36s14.45-.44 18.8-3.55 22.22-6.8 23.3-1.83 21.71 24.73 5.4 24.86-37.89-2.54-42.24-5.19-5.26-14.29-5.26-14.29z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M127.87 573.12c-16.31.13-37.89-2.54-42.24-5.19-3.31-2-4.63-9.25-5.07-12.59h-.48s.91 11.65 5.26 14.3 25.93 5.32 42.24 5.19c4.71 0 6.33-1.71 6.24-4.19-.65 1.51-2.45 2.45-5.95 2.48z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#e2e7f0",
    d: "M401.48 115.52h197.63v66.68H401.48z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M415.5 118.08h50.25v61.37H415.5z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M426.13 136.44h29.48v23.68h-29.48z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M476.38 118.08h50.25v61.37h-50.25z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M487.01 136.44h29.48v23.68h-29.48z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M537.26 118.08h50.25v61.37h-50.25z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M547.89 136.44h29.48v23.68h-29.48z"
  }), React.createElement("path", {
    d: "M599.12 115.52v5H401.49v-5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M589.67 77.06l-26.31-20.29H435.64l-24.26 20.11h.13c-7.73 3.77-24.31 10-43.87 6.07 0 0 1 34.8 35 34.8H600.4s28.42 1.28 32.57-34.8a79.42 79.42 0 0 1-43.3-5.89z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#e2e7f0",
    d: "M364.35 251.74h279.3v94.24h-279.3z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M384.15 247.64h71.02v86.73h-71.02z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M399.17 273.59h41.66v33.46h-41.66z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M470.19 247.64h71.02v86.73h-71.02z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M485.22 273.59h41.66v33.46h-41.66z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M556.24 247.64h71.02v86.73h-71.02z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M571.26 273.59h41.66v33.46h-41.66z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M337.71 449.77H677.1v118.82H337.71z"
  }), React.createElement("path", {
    fill: "#e2e7f0",
    d: "M337.71 449.77H677.1v118.82H337.71z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M373.22 449.77h102.43v116.09H373.22z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M393.71 449.77h61.46v116.09h-61.46z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M407.37 466.85h30.73v82.63h-30.73zM537.8 449.77h102.43v116.09H537.8z"
  }), React.createElement("path", {
    fill: "#fff",
    opacity: 0.4,
    d: "M558.29 449.77h61.46v116.09h-61.46z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M571.94 466.85h30.73v82.63h-30.73z"
  }), React.createElement("path", {
    d: "M720.81 563.13V449.78c9-.15 60.2-4.12 68.29-74.44 0 0-44.31 8.74-92.53-12.56l-56.34-43.44H367.08l-51.9 43h.28c-16.53 8.06-52 21.34-93.83 13 0 0 1.92 69.45 67.61 74.17v113.62m0 0h431.57m-23.9 0H313.13m0 0V449.77h383.78v113.36",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M364.35 251.74h279.3v12.1h-279.3z"
  }), React.createElement("path", {
    d: "M636.56 199.56l-37.81-30.74H401.37l-34.67 30.44h.2c-11.7 5.71-36.78 15.1-66.39 9.18 0 0 1.45 52.67 52.91 52.67h299.33s43 1.93 49.29-52.67c-.04 0-31.36 6.19-65.48-8.88z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M337.37 449.43h339.39v3.45H337.37zM315.52 362.71h381.05s-164.57 13.82-381.05 0zM364 198.81h272.48s-117.68 13.83-272.48 0zM411.12 76.58H590s-77.23 13.83-178.88 0z"
  }), React.createElement("path", {
    fill: "#d8e2f0",
    d: "M58.29 562.14H1008v25.61H58.29z"
  }), React.createElement("path", {
    d: "M228.52 425.54l6.37 18.12-4.89 30.42s-7.39 24.27-6.65 36 0 27.95 0 27.95-17.74 32.36-3 45.6c3.43 3.07 6.31 2.46 8.7-.3a76.24 76.24 0 0 0 7.41 3.6l-12.41 48.19-11.82 23.54s-25.09 21.34-34.7 66.22c0 0-9.58 29.89-15.69 38.81a12.2 12.2 0 0 1-.91 1.2 50.35 50.35 0 0 1-2.62-4.71l-11.08 29.42s22.17 12.5 37.69 17.65 33.26-.74 38.43-7.35-10.35-14-21.43-18.39c-5.38-2.14-8.31-7.22-9.92-11.89-.14-1.44-.26-3.06-.31-4.81-.24-8.35 1-19.62 8-28.17C212.27 721.2 231.48 683 231.48 683s19.21-20.59 23.65-28.68l26.61-44.42c14.76 16.68 29.55 56.1 29.55 56.1l5.91 36s19.21 51.48 25.13 56.63c.17.14.33.31.49.47l.15.16.35.41.14.18c.15.19.31.4.46.61l.11.16.36.54.17.27.31.53.15.25.42.78.15.29.29.58.17.34.3.64.12.27.39.9.15.35.26.65.14.36.33.85.08.21.34.93.12.35.26.74.11.31.34 1v.14l.29.92.1.31.26.84.06.21.31 1 .06.21.23.82.08.3.21.78.06.22.24.88.11.43.11.43.13.52v.14c.17.68.33 1.32.47 1.9l.17.74.08.35v.09a27.39 27.39 0 0 1-3.09-2.38 84.06 84.06 0 0 1 0 14.71c-.74 7.35 6.65 17.65 6.65 17.65s66.51-16.18 70.2-27.21-11.82-9.56-16.26-8.09-26.46-2.78-29.46-7.93a14.22 14.22 0 0 0-2-2.63 4.21 4.21 0 0 0-5.13-.85l-.17-.18-.2-.23-.13-.16-.24-.31c-.16-.22-.32-.46-.49-.71l-.18-.27q-.44-.7-.9-1.51l-.06-.1c-4.72-8.61-9.79-26.17-11-30.35v-.09l-.1-.34V731.54l-17-55.16c5.17-19.86 0-29.42 0-29.42l-9.61-44.86-5.42-20.32c.17-.17.25-.28.25-.28-4.42-12.36-7.89-38.58-10-58.84q-.21-2-.4-3.86l16.36 7.54s22.17 33.83 36.21 17.65-28.08-30.16-28.08-30.16L315 496.18l-.06-.77-3-22.06s-8.13-26.48-4.43-44.13c3.15-15-7.11-20.46-10.22-21.74a9.88 9.88 0 0 0-1.5-.44c-4.05-1-8.57-5.08-12.41-9.5a48.66 48.66 0 0 0-11.38-9.68 11.32 11.32 0 0 0 4.83-7.16c.62-3.39-.55-6.76-1.59-10.09a90.14 90.14 0 0 1 5.23-10.72h.12q.46-.79.9-1.49a32 32 0 0 0 28.36-31.77 31.72 31.72 0 0 0-4-15.43c3.31-1.15 6.49-2.6 5.29-6-.81-2.3-3-3.8-4.65-5.57-4.45-4.68-5.81-11.71-10.47-16.19a15.92 15.92 0 0 0-4.61-3.05c-4.73-2.68-10.79-3-16.26-2-6.77 1.24-13.08 4.22-19.68 6.14-5.81 1.68-11.89 2.55-17.46 4.92-9.5 4-16.81 12.26-21.2 21.57-3.88 8.23-5.68 17.34-9.92 25.39s-12 15.3-21.15 15c-2.36-.08-4.8-.65-7 .17a8.56 8.56 0 0 0-4.08 3.72c-5 8.16-1.79 19.15-5.77 27.85-3 6.47-9.35 10.56-14.59 15.41s-9.74 12.08-7.27 18.76a13.67 13.67 0 0 0 7.57 7.42 19.23 19.23 0 0 0 5.53 2c5 1 10.09.4 15.14 0 13.67-1 28.61-.45 39.46-8.77 4.47-3.43 7.91-8.16 11.49-12.63a94.41 94.41 0 0 0 2.3 20.2zm19.68 46.25c1.11 1.83 2.24 3.65 3.41 5.45 10.86 16.68-3.87 39.5-3.87 39.5a40 40 0 0 0-8.55 9.72c.19-7 1-15 3.38-20.75 3.67-8.9 5.11-25.23 5.63-33.92z",
    transform: "translate(-96 -78.12)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M141.09 361.7l-5.77 35.92s-7.22 23.71-6.5 35.2 0 27.3 0 27.3-17.32 31.61-2.89 44.54 18.77-40.95 18.77-40.95-2.17-23 2.89-35.2 5.77-38.79 5.77-38.79z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M141.09 361.7l-5.77 35.92s-7.22 23.71-6.5 35.2 0 27.3 0 27.3-17.32 31.61-2.89 44.54 18.77-40.95 18.77-40.95-2.17-23 2.89-35.2 5.77-38.79 5.77-38.79z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M225.66 485.22l10 37.4 9.34 43.82s5.05 9.34 0 28.73l16.6 53.88s9.38 34.48 15.16 35.2-5.77 27.3-5.77 27.3l-15.88-9.34s-4.31-21.55-10.11-26.58-24.54-55.31-24.54-55.31l-5.77-35.2s-18-48.13-33.92-59.62-20.93-30.17-20.93-30.17z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M159.85 495.32s5.05 18.68 20.93 30.17 33.92 59.62 33.92 59.62l5.77 35.2s18.77 50.29 24.54 55.31c4.24 3.69 7.7 16.29 9.24 22.72.56 2.33.87 3.86.87 3.86l15.88 9.35s11.55-26.58 5.77-27.3c-.9-.11-1.88-1-2.9-2.51-5.56-8.06-12.26-32.69-12.26-32.69L245 595.17c5.05-19.4 0-28.73 0-28.73l-9.38-43.82-10-37.4z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M67.46 682.09l5.77 13.65 26-2.87a59.67 59.67 0 0 1-1.33-11.28c-.23-8.15 1-19.16 7.82-27.51 12.27-15.09 31-52.44 31-52.44s18.77-20.11 23.1-28L196 513.3l-1.14-5.42 9.74-9H144l-14.44 56-11.56 23s-24.54 20.83-33.92 64.65c0 0-9.36 29.19-15.32 37.91a10.48 10.48 0 0 1-1.3 1.65z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M254.26 698.35c.56 2.33.87 3.86.87 3.86l15.87 9.34s11.55-26.58 5.77-27.3c-.9-.11-1.88-1-2.9-2.51a4 4 0 0 0-1.85 4.48 11.1 11.1 0 0 0 1.14 3.07c2.17 3.59-7.22 9.34-7.22 9.34-3.14 4.03-8.28 1.9-11.68-.28z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M272.76 687.64a4.19 4.19 0 0 1 7.14-3.76 13.89 13.89 0 0 1 1.94 2.57c2.89 5 24.54 9.34 28.87 7.9s19.49-2.87 15.88 7.9S258 728.79 258 728.79s-7.22-10.06-6.5-17.24a82.1 82.1 0 0 0 0-14.37s10.11 9.34 15.16 2.87c0 0 9.38-5.75 7.22-9.34a11.1 11.1 0 0 1-1.12-3.07z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M67.46 682.09l5.77 13.65 26-2.87a59.67 59.67 0 0 1-1.33-11.28 3.56 3.56 0 0 0-5.8-.83c-1.34 1.44-2.7 3-3.7 4.2-2.89 3.59-12.27 1.44-12.27 1.44-2.43.8-5.32-2.69-7.38-5.91a10.48 10.48 0 0 1-1.29 1.6z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M91.38 682.2a3.55 3.55 0 0 1 6 1.49c1.31 5.11 4.19 11.71 10.47 14.21 10.83 4.31 26 11.49 20.93 18s-22.38 12.21-37.53 7.18-36.81-17.24-36.81-17.24l10.83-28.73s5.8 12.17 10.13 10.77c0 0 9.38 2.16 12.27-1.44 1.01-1.29 2.33-2.8 3.71-4.24z",
    fill: "#dce6f2"
  }), React.createElement("path", {
    d: "M189.45 278.37s-17.32 23.71-13 40.23-34.65-10.78-34.65-10.78 20.21-18 16.6-47.41z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M132.43 503.22c28.87 17.24 63.52 10.06 63.52 10.06l-.72-5 1.5.14c27.59 2.43 33.87-5.89 33.87-5.89-4.32-12.08-7.7-37.68-9.81-57.47-.3-2.84-.58-5.57-.83-8.12-.57-5.77-1-10.62-1.27-13.91-.24-2.89-.36-4.55-.36-4.55l-2.9-21.6s-7.94-25.86-4.33-43.1c3.07-14.68-6.94-20-10-21.24a9.64 9.64 0 0 0-1.47-.43c-4-.93-8.37-5-12.12-9.28a48.67 48.67 0 0 0-20.25-13.75c-3.63-1.31-6.71-2.71-6.71-2.71-5.05-5.75-18.77-2.16-18.77-2.16-16.6 10.78-7.94 46-7.94 46l6.9 19.63a145.54 145.54 0 0 0 15.65 30.88c10.61 16.29-3.78 38.58-3.78 38.58-22.35 17.94-20.18 63.92-20.18 63.92z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M194.14 469.82l2.58 38.58c27.59 2.43 33.87-5.89 33.87-5.89-4.32-12.08-7.7-37.68-9.81-57.47-.3-2.84-.58-5.57-.83-8.12z",
    opacity: 0.05
  }), React.createElement("path", {
    d: "M148.31 368.88s13 24.42 17.32 35.2 4.33 7.18 6.5 10.78 25.26 19.4 25.26 19.4l23.39 10.78c-1-9.28-1.7-17.29-2.1-22l-22-14.61s-15.16-9.34-15.88-21.55-10.11-34.48-10.11-34.48-18.78-20.15-26.69-10.81 4.31 27.29 4.31 27.29z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M170.68 348.77s9.38 22.27 10.11 34.48 15.88 21.55 15.88 21.55l47.64 31.61s41.14 13.65 27.43 29.45-35.37-17.24-35.37-17.24l-39-18s-23.1-15.8-25.26-19.4-2.17 0-6.5-10.78-17.32-35.2-17.32-35.2-12.27-18-4.33-27.3 26.72 10.83 26.72 10.83z",
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M176.46 358.11s-14.46-10.77-17.33-14.37c-1.27-1.59-3.25-1.35-5.06-.59a22.84 22.84 0 0 1-10.73 1.73c-3.16-.27-6.23-.09-5.86 1.71.72 3.59-2.17-18.68-2.17-18.68l12.27-4.31 15.88 8.62z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M176.46 356.67s-14.46-10.79-17.33-14.36c-1.27-1.59-3.25-1.35-5.06-.59a22.84 22.84 0 0 1-10.72 1.76c-3.16-.27-6.23-.09-5.86 1.71.72 3.59-2.17-18.68-2.17-18.68l12.27-4.31 15.88 8.62z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M210.45 358.11a17.78 17.78 0 0 1-16.31-1.08M163.1 262.21c.54-4.29-4.8 4.62-5.41-.36l31 18s-1.77 2.43-4 6.26a31.84 31.84 0 0 1-3.54.2c-9.34-.04-12.3-17.66-18.05-24.1z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 181.87,
    cy: 253.59,
    rx: 31.4,
    ry: 31.25,
    fill: "#ffcdd3"
  }), React.createElement("path", {
    d: "M196 254.13c-.24 2-.19 4-1.13 5.78-1.31 2.44-4.14 3.55-6.51 5-9.59 5.88-12.44 19.11-9.38 29.9 1.08 3.82 2.79 7.69 2.08 11.6-1.22 6.71-8.9 10.19-15.72 10.78s-14-.5-20.35 2c-10.77 4.14-15.49 16.69-24.6 23.69-10.6 8.13-25.2 7.63-38.54 8.57-4.94.35-9.94.94-14.79 0s-9.63-3.89-11.35-8.51c-2.42-6.52 2-13.59 7.1-18.32s11.35-8.72 14.25-15c3.89-8.5.75-19.23 5.64-27.2a8.36 8.36 0 0 1 4-3.63c2.16-.81 4.55-.25 6.85-.17 8.91.31 16.52-6.77 20.66-14.63s5.9-16.76 9.69-24.8c4.28-9.1 11.42-17.12 20.71-21.07 5.44-2.31 11.37-3.16 17.05-4.81 6.45-1.87 12.61-4.78 19.22-6s14.1-.41 18.93 4.24c4.55 4.38 5.88 11.24 10.22 15.82 1.64 1.73 3.75 3.19 4.54 5.44 1.87 5.32-7.22 5.77-10.25 7.9a19.84 19.84 0 0 0-8.32 13.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M194.51 253.42c-.24 2-.19 4-1.13 5.78-1.31 2.44-4.14 3.55-6.51 5-9.59 5.88-12.44 19.11-9.38 29.9 1.08 3.82 2.79 7.69 2.08 11.6-1.22 6.71-8.9 10.19-15.72 10.78s-14-.5-20.35 2c-10.72 4.16-15.44 16.67-24.55 23.67-10.6 8.13-25.2 7.63-38.54 8.57-4.94.35-9.94.94-14.79 0s-9.63-3.89-11.35-8.51c-2.42-6.52 2-13.59 7.1-18.32s11.35-8.72 14.25-15c3.89-8.5.75-19.23 5.64-27.2a8.36 8.36 0 0 1 4-3.63c2.16-.81 4.55-.25 6.85-.17 8.91.31 16.52-6.77 20.66-14.63s5.9-16.76 9.69-24.8c4.28-9.1 11.42-17.12 20.71-21.07 5.44-2.31 11.37-3.16 17.05-4.81 6.45-1.87 12.61-4.78 19.22-6s14.1-.41 18.93 4.24c4.55 4.38 5.88 11.24 10.22 15.82 1.64 1.73 3.75 3.19 4.54 5.44 1.87 5.32-7.22 5.77-10.25 7.9a19.84 19.84 0 0 0-8.37 13.44z",
    fill: "#2d283d"
  }));
};
UndrawSunnyDay.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawSunnyDay;